import { CONST } from '@/utils/constants'

export const Public = {
  Login: () => `${CONST.Services.Paths.Vue}/login`,
  ForgotPassword: () => `${CONST.Services.Paths.App}/ChangePassword`
}

export const App = {
  Home: () => `${CONST.Services.Paths.Vue}/home`,
  Open: {
    // Official
    Workspace: (id) => `${CONST.Services.Paths.Vue}/workspace/${id}`,
    Visualization: (id) => `${CONST.Services.Paths.Vue}/visualization/${id}`,
    List: (id) => `${CONST.Services.Paths.Vue}/list/${id}`,
    Chart: (id) => `${CONST.Services.Paths.Vue}/chart/${id}`,
    Metric: (id) => `${CONST.Services.Paths.Vue}/metric/${id}`,
    User: (id) => `${CONST.Services.Paths.Vue}/user/${id}`,
    Group: (id) => `${CONST.Services.Paths.Vue}/group/${id}`,
    Discussion: (id) => `${CONST.Services.Paths.Vue}/discussion/${id}`,
    Alert: (id) => `${CONST.Services.Paths.Vue}/alert/${id}`,
    Distribution: (id) => `${CONST.Services.Paths.Vue}/distribution/${id}`,
    // Aliases
    View: (id) => `${CONST.Services.Paths.Vue}/visualization/${id}`,
    Grid: (id) => `${CONST.Services.Paths.Vue}/list/${id}`,
    Trigger: (id) => `${CONST.Services.Paths.Vue}/alert/${id}`
  }
}

export const GWT = {
  Welcome: () => `${CONST.Services.Paths.GWT}#welcome:`,
  Hub: () => `${CONST.Services.Paths.GWT}#hub:`,
  Search: () => `${CONST.Services.Paths.GWT}#search:`,
  Workspace: (id, page = 0) => `${CONST.Services.Paths.GWT}#workspace:id=${id};p=${page}`,
  Profile: (id) => `${CONST.Services.Paths.GWT}#userprofile:id=${id}`,
  Groups: (id) => `${CONST.Services.Paths.GWT}#groups:id=${id}`,
  Discussions: () => `${CONST.Services.Paths.GWT}#discussions:`,
  Notifications: () => `${CONST.Services.Paths.GWT}#alerts:category=Notification`,
  Alerts: () => `${CONST.Services.Paths.GWT}#alerts:category=Trigger`,
  Tasks: () => `${CONST.Services.Paths.GWT}#tasks:`,
  Browse: {
    All: () => `${CONST.Services.Paths.GWT}#search:types=Workspace,Grid,Chart,Metric,Distribution,Trigger,Group,Discussion,User;sort=Name`,
    Workspaces: () => `${CONST.Services.Paths.GWT}#search:types=Workspace;sort=Name`,
    Distributions: () => `${CONST.Services.Paths.GWT}#search:types=Distribution;sort=Name`,
    Reports: () => `${CONST.Services.Paths.GWT}#search:types=Grid;sort=Name`,
    Charts: () => `${CONST.Services.Paths.GWT}#search:types=Chart;sort=Name`,
    Metrics: () => `${CONST.Services.Paths.GWT}#search:types=Metric;sort=Name`,
    People: () => `${CONST.Services.Paths.GWT}#search:types=User;sort=Name`,
    Groups: () => `${CONST.Services.Paths.GWT}#search:types=Group;sort=Name`,
    Alerts: () => `${CONST.Services.Paths.GWT}#search:types=Trigger;sort=Name`,
    Discussions: () => `${CONST.Services.Paths.GWT}#search:types=Discussion;sort=Name`,
  }
}

export const Links = {
  Help: () => 'https://welcome.gohubble.com/help',
  Copyright: () => 'https://welcome.gohubble.com/copyright',
  PrivacyPolicy: () => 'https://welcome.gohubble.com/privacy',
  ProductSite: () => 'https://gohubble.com',
  CorporateSite: () => 'https://insightsoftware.com'
}

export const URLS = {
  Public,
  App,
  GWT,
  Links
}

export default URLS
